import axios from 'axios';
import { supabase } from '../lib/supabase/client/supabaseClient';

interface InvoiceResponse {
    success: boolean;
    message: string;
    updatedFiles: Array<{
        emailInvoicePath: string;
        combined_file?: string;
        groupId?: string;
    }>;
}

class WalletPaymentService {
    private baseUrl = process.env.REACT_APP_RAZORPAY_URL || 'http://localhost:5001/new-server';

    async deductWalletBalance(userId: string, amount: number): Promise<boolean> {
        const { data, error } = await supabase
            .schema('api')
            .rpc('deduct_wallet_balance', {
                user_id_param: userId,
                amount_to_deduct: amount
            });

        if (error) throw error;
        return data;
    }

    async addWalletTransaction(userId: string, amount: number, paymentType: 'print_bazaar_purchase' | 'print_order') {
        const reason = paymentType === 'print_bazaar_purchase' 
            ? 'Print Bazaar Purchase' 
            : 'Print Order Payment';

        const { error } = await supabase
            .schema('api')
            .rpc('add_wallet_transaction', {
                user_id_param: userId,
                amount_param: amount,
                transaction_type_param: 'DEBIT',
                reason_param: reason
            });

        if (error) throw error;
    }

    async createInvoice(orderData: {
        orderId: string;
        session: string;
        orderSummary: any;
        fileCosts: number[];
        userInfo: any;
        totalCost: number;
        shop_id?: string;
    }): Promise<InvoiceResponse> {
        try {
            const { data } = await axios.post<InvoiceResponse>(
                `${this.baseUrl}/create-invoice`,
                orderData
            );
            return data;
        } catch (error) {
            console.error('Error creating invoice:', error);
            throw error;
        }
    }

    // NEW: Submit jobs to backend immediately (fast path for wallet payments)
    async submitJobsOnly(orderData: {
        orderId: string;
        session: string;
        orderSummary: any;
        fileCosts: number[];
        userInfo: any;
        totalCost: number;
        shop_id?: string;
    }): Promise<InvoiceResponse> {
        try {
            const { data } = await axios.post<InvoiceResponse>(
                `${this.baseUrl}/submit-wallet-jobs`,
                orderData
            );
            return data;
        } catch (error) {
            console.error('Error submitting jobs:', error);
            throw error;
        }
    }

    // NEW: Generate invoices in background (don't wait for response)
    async generateInvoicesAsync(orderData: {
        orderId: string;
        session: string;
        orderSummary: any;
        fileCosts: number[];
        userInfo: any;
        totalCost: number;
        shop_id?: string;
    }): Promise<void> {
        try {
            // Fire and forget - don't await response
            axios.post(
                `${this.baseUrl}/generate-invoice-async`,
                orderData
            ).catch(error => {
                console.error('Background invoice generation failed:', error);
            });
        } catch (error) {
            console.error('Error triggering invoice generation:', error);
        }
    }
}

export default new WalletPaymentService();
